export default __webpack_public_path__ + "static/media/shopping_cart.5dc21c56.svg";